import { BRAND_COLORS, CorNomeada, resolveCorName } from '../../theme';

// Cor nomeada → classe `-theme` legada (espelha ConfigSkinService/colors.ts).
// Existem DUAS famílias de classe que definem as variáveis --default-color*:
// `body-<cor>` (em _theme-colors.scss) e `<x>-theme` (em styles.scss +
// _theme-colors.scss). Aplicamos as duas para a cor certa e removemos todas as
// outras, de modo que a cor da conta vença independentemente da ordem do CSS
// compilado — inclusive sobre a `default-theme` (azul) que o login legado sempre
// injeta no body via setThemeSkin, e que de outra forma sobrescreveria a nossa.
const COR_TO_THEME_CLASS: Readonly<Record<CorNomeada, string>> = {
  azul: 'default-theme',
  verde: 'green-theme',
  amarelo: 'yellow-theme',
  dourado: 'golden-theme',
  laranja: 'orange-theme',
  vermelho: 'red-theme',
  preto: 'black-theme',
  cinza: 'gray-theme',
  roxo: 'purple-theme',
};

const SKIN_BODY_CLASSES: string[] = Object.keys(BRAND_COLORS).map((cor) => `body-${cor}`);
const SKIN_THEME_CLASSES: string[] = Object.values(COR_TO_THEME_CLASS);

/** Classe `body-<cor>` da cor da conta; `body-azul` quando ausente/desconhecida. */
export function resolveSkinBodyClass(cor: string | null): string {
  return `body-${resolveCorName(cor)}`;
}

/**
 * Torna o shell autoritativo sobre a cor da folha Angular: remove todas as classes
 * de cor concorrentes do body (as `body-<cor>` e as `<x>-theme`, incluindo a
 * `default-theme` residual do login) e aplica a `body-<cor>` e a `-theme` da cor
 * resolvida, garantindo o valor correto de --default-color* independentemente da
 * ordem do CSS compilado.
 */
export function applySkinBodyClass(cor: string | null): void {
  const name = resolveCorName(cor);
  [...SKIN_BODY_CLASSES, ...SKIN_THEME_CLASSES].forEach((className) =>
    document.body.classList.remove(className),
  );
  document.body.classList.add(`body-${name}`);
  document.body.classList.add(COR_TO_THEME_CLASS[name]);
}
